import { Flex, Group, Stack, Text } from '@mantine/core';

import { CenterReportButton } from '@/module/ResearchCenter/components/CenterReportButton';

import { AddButtonLink, Content, EditButtonLink } from '@/core/components';

import { useCurrentUser } from '@feature/security';

import { ResearchCenterDeleteButton } from './components/ResearchCenterDeleteButton';
import { ResearchCenter } from './model/ResearchCenterTypes';

interface ResearchCenterViewProps {
  researchCenter: ResearchCenter;
}

export function ResearchCenterView(props: ResearchCenterViewProps) {
  const { researchCenter } = props;
  const { name } = researchCenter;
  const { currentRole } = useCurrentUser();

  return (
    <Content type="full">
      <Stack gap="10px">
        <Flex justify="space-between">
          <Text fw="500">{name}</Text>
          <Group>
            {(currentRole === 'UNIVERSITY_ADMIN' || currentRole === 'RESEARCH_CENTER_ADMIN') && (
              <CenterReportButton researchCenterId={researchCenter.id} />
            )}
            <EditButtonLink
              size="xs"
              miw="100px"
            />
            <ResearchCenterDeleteButton researchCenter={researchCenter.id} />
          </Group>
        </Flex>

        <Flex justify="end">
          <AddButtonLink name="Add lab" />
        </Flex>
      </Stack>
    </Content>
  );
}
